// Lightweight, safe GA4 (gtag) event helper.
// gtag is loaded globally in index.html. This wrapper never throws if it is
// missing (ad-blockers, consent tools, SSR) so analytics can never break a page.
type GtagParams = Record<string, string | number | boolean | undefined>;

type GtagFn = (command: "event", name: string, params?: GtagParams) => void;

export function trackEvent(name: string, params: GtagParams = {}): void {
  if (typeof window === "undefined") return;
  const gtag = (window as unknown as { gtag?: GtagFn }).gtag;
  if (typeof gtag !== "function") return;
  try {
    gtag("event", name, params);
  } catch {
    // Analytics must never break the app.
  }
}
